exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%,-50%);\n            transform: translate(-50%,-50%);\n}\n\n.not-found #not-found-number{\n    font-size: 80pt;\n    font-weight: 600;\n    text-align: center;\n    color: #28bcbc;\n    margin-bottom: 0px;\n}\n\n.not-found-message{\n    font-size: 22pt;\n    font-weight: 200;\n    text-align: center;\n    color: #28bcbc;\n    margin-bottom: 10px;\n}\n\n.not-found-button{\n    display: block;\n    margin: auto;\n}", ""]);

// exports
